<template>
  <section class="admin-panel form">
    <mdb-container>
      <mdb-row>
        <mdb-col md="12">
          <h1 class="text-left">
            <strong>Video</strong>
          </h1>
          <h6 class="mb-5">
            <router-link to="/admin/videos">
              <mdb-icon icon="arrow-left" />Back
            </router-link>| Editing:
            <span class="text-uppercase">{{newOrEditedVideo.name}}</span>
          </h6>
          <form class="mb-5" v-on:submit.prevent>
            <!-- Default input name -->
            <mdb-row class="">
              <mdb-col md="6" class="py-3 pr-md-5" >
                <label for="name" class="grey-text">Name</label>
                <input
                  required
                  type="text"
                  v-model="newOrEditedVideo.name"
                  id="name"
                  class="form-control"
                />
                <label for="image" class="grey-text">Image</label>
                <input type="text" id="image" class="form-control" />

                <label for="excerpt" class="grey-text">Excerpt</label>
                <textarea
                  v-model="newOrEditedVideo.excerpt"
                  class="form-control"
                  id="excerpt"
                  rows="5"
                ></textarea>
                <label for="transcript" class="grey-text">Transcript</label>
                <textarea
                  v-model="newOrEditedVideo.transcript"
                  class="form-control"
                  id="transcript"
                  rows="5"
                ></textarea>
              </mdb-col>
              <mdb-col md="6" class=" py-3 white">
                <label for="vimeoId" class="grey-text">
                  Vimeo ID
                  <template v-if="newOrEditedVideo.vimeoduration > 0">(duration: {{newOrEditedVideo.vimeoduration}})</template>
                </label>
                <input
                  required
                  type="text"
                  v-model="newOrEditedVideo.vimeoid"
                  id="vimeoId"
                  class="form-control"
                  @change="mthVimeoidChanged()"
                />
                <iframe
                  class="black"
                  :src="mthGetVideoToPlay()"
                  frameborder="0"
                  width="100%"
                  height="100%"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                ></iframe>
              </mdb-col>
            </mdb-row>

            <mdb-row>
              <mdb-btn @click="saveVideo()" color="primary" class="btn-sm my-4" rounded>Save</mdb-btn>
              <router-link to="/admin/videos">
                <mdb-btn color="primary" class="btn-sm my-4" rounded>Back to list</mdb-btn>
              </router-link>
            </mdb-row>
          </form>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbView,
  mdbCardBody,
  mdbTbl,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";
import firebase from "firebase/app";
import { store } from "../store";
import Player from "@vimeo/player";


export default {
  name: "AdminVideosEdit",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbView,
    mdbCardBody,
    mdbTbl,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter
  },
  data() {
    return {
      modal: false,
      newOrEditedVideo: {
        name: "",
        vimeoid: "",
        vimeoduration: 0,
        excerpt: "",
        transcript: ""
      }
    };
  },
  methods: {
    mthGetVideoToPlay() {
      return "https://player.vimeo.com/video/" + this.newOrEditedVideo.vimeoid;
    },
    mthVimeoidChanged() {
      console.log("chg" + this.newOrEditedVideo.vimeoid);

      //var vid=this.newOrEditedVideo.vimeoid

      let that=this
      var iframe = window.document.querySelector("iframe");

      const player = new Player(iframe, {
        id: that.newOrEditedVideo.vimeoid,
        width: 640
      });

      const toret={dur: -1}
      player
        .getDuration()
        .then(function(duration) {
          // duration = the duration of the video in seconds
          console.log("dura=" + duration);
          toret.dur=duration

          that.newOrEditedVideo.vimeoduration=duration


        })
        .catch(function(error) {
          console.log(error);

        });

        this.$nextTick(function(){that.$forceUpdate()})

      //return thot.toret.dur
      console.log(toret);
      //return toret



      // const player = new Player("handstick", {
      //   id: 19231868,
      //   width: 640
      // });

      // player.on("play", function() {
      //   console.log("played the video!");
      // });

      //console.log(item);





    },
    saveVideo() {
      console.log("save clicked");
      console.log(this.$router.currentRoute.path.includes("add"));

      if (this.$router.currentRoute.path.includes("add"))
        firebase
          .firestore()
          .collection("videos")
          .add(this.newOrEditedVideo);

      if (this.$router.currentRoute.path.includes("edit")) {
        firebase
          .firestore()
          .collection("videos")
          .doc(this.$router.currentRoute.params.videoid)
          .update(this.newOrEditedVideo);
    }
    },
    resizeIframe() {
      let iFrame = window.document.getElementsByTagName('iframe');
      let iFrameWidth = iFrame[0].clientWidth;
      let iFrameHeight = iFrameWidth * 9 / 16;
      window.document.getElementsByTagName('iframe')[0].height = iFrameHeight;
    },
  },
  created() {
    firebase
      .firestore()
      .collection("videos")
      .doc(this.$router.currentRoute.params.videoid)
      .get()
      .then(result => {
        this.newOrEditedVideo = result.data();
      });
  },
  mounted: function () {
    var that = this;
    this.$nextTick(function () {
      //  sprawdza wielkośc iframe
      that.resizeIframe();

      window.addEventListener('resize', function() {
        that.resizeIframe();
      });

    })
  }



};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.card-cascade .view.gradient-card-header {
  padding: 1rem 1rem;
  text-align: center;
}

.card.card-cascade h3,
.card.card-cascade h4 {
  margin-bottom: 0;
}


</style>
